import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Carousel, Button, Form, Input, message } from "antd";
import { MyIcon } from "../../common/baseConfig";
import { cookies } from "../../utils";
import { common } from "../../utils";
const FormItem = Form.Item;
const formItemLayout = {
  labelCol: {
    span: 8
  },
  wrapperCol: {
    span: 16
  },
};

const tailFormItemLayout = {
  wrapperCol: {
    span: 16,
    offset: 8,
  },
};
export class AccountBindPhone extends Component {
  static propTypes = {
    center: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    phone: "",
    codeTxt: "获取验证码",
  }
  bindPhone = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      values.StuID = cookies.getCookie('UserKey');
      if (!err) {
        this.props.actions.fetchEditStuInfoPhone(values).then(res => {
          if (res.SuccessResponse) {
            this.props.actions.fetchStudentBasics({ StuID: cookies.getCookie('UserKey') });
            message.success(res.Message);
          }
        })
      }
    })
  }
  getCode() {
    let stuID = cookies.getCookie('UserKey');
    if (this.state.phone.trim() === "") {
      message.warn("手机号码不能为空");
      return;
    }
    if (common.checkPhone(this.state.phone)) {
      let seconds = 60;
      this.setState({
        codeTxt: "发送中..."
      })
      this.props.actions.fetchGetStuInfoCode({
        StuID: stuID, Phone: this.state.phone
      }).then(res => {
        if (res.SuccessResponse) {
          message.success(res.Message);
          let timer = setInterval(() => {
            if (seconds > 0) {
              this.setState({
                codeTxt: `${seconds--}秒`
              })
            } else {
              clearInterval(timer);
              this.setState({
                codeTxt: "获取验证码"
              })
            }
          }, 1000)
        } else {
          this.setState({
            codeTxt: "获取验证码",
          })
        }
      })
    } else {
      message.warn("请输入正确的手机号")
    }
  }
  render() {
    const { studentBasics } = this.props.common;
    const { getFieldDecorator } = this.props.form;
    const { codeTxt } = this.state;
    let Phone = "";
    if (JSON.stringify(studentBasics) !== "{}") {
      Phone = studentBasics.Phone;
    }
    return (
      <div className="center-account-bind-phone">
        <Carousel dots={false} ref="carousel" effect="fade">
          <div className="content1">
            <div className="info">
              <h1>
                <MyIcon type="iconshouji" className="phone" />
                <div>
                  <p className="p1">
                    <span>绑定手机号:</span><span>{Phone}</span>
                  </p>
                  <p className="p2">
                    可通过手机号加密码登录，可通过手机号码找回密码!
                  </p>
                </div>
              </h1>
              <Button type="theme" onClick={() => {
                this.refs.carousel.next();
              }}>更绑手机号</Button>
            </div>
          </div>
          <div className="content2">
            <h2>
              <p>绑定手机</p>
              <p onClick={() => {
                this.refs.carousel.prev();
              }}>返回上一页</p>
            </h2>
            <div className="form">
              <Form onSubmit={this.bindPhone} autoComplete="off">
                <FormItem {...formItemLayout} label='登录密码'>
                  {getFieldDecorator("Password", {
                    initialValue: '',
                    rules: [{
                      required: true, message: "请输入登录密码"
                    }]
                  })(<Input
                    type="password"
                    autoComplete='off'
                    placeholder="请输入登录密码"
                    style={{ width: 300, height: 40, }} />)}
                </FormItem>
                <FormItem {...formItemLayout} label="新手机号码">
                  {getFieldDecorator("NewPhone", {
                    initialValue: '', rules: [
                      { required: true, message: "请输入新手机号码" },
                      { pattern: "^[1][3,4,5,6,7,8,9][0-9]{9}$", message: "请输入正确的手机号" }
                    ]
                  })(
                    <Input
                      placeholder="请输入绑定手机号"
                      onChange={e => this.setState({
                        phone: e.target.value
                      })}
                      style={{ width: 300, height: 40, }}
                    />
                  )}
                </FormItem>
                <FormItem {...formItemLayout} label="验证码">
                  {getFieldDecorator("PhoneCode", {
                    initialValue: '', rules: [
                      { required: true, message: "请输入验证码" },]
                  })(
                    <Input type="text" placeholder="请输入验证码" style={{ width: 300, height: 40, }} suffix={
                      <span className="getCodeTxt" onClick={() => {
                        if (codeTxt === "获取验证码") {
                          this.getCode();
                        }
                      }}>{codeTxt}</span>
                    } autoComplete="off" />
                  )}
                </FormItem>
                <FormItem {...tailFormItemLayout}>
                  <Button type="theme" htmlType="submit" className="submitBtn">立即绑定</Button>
                </FormItem>
              </Form>
            </div>
          </div>
        </Carousel>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    center: state.center,
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create()(AccountBindPhone));



// WEBPACK FOOTER //
// ./src/features/center/AccountBindPhone.js